import AsoHeader from '../../../components/Aso/Header';
import AsoDisparoSms from '../../../components/Aso/Register/DisparoSms';

const AsoRegistroDisparaSms: React.FC = () => {

  return (
    <div>
      <AsoHeader />
      <AsoDisparoSms />
    </div>
  );
}

export default AsoRegistroDisparaSms